<template>
  <div class="row">
    <div v-if="$slots.items && $slots.items.length > itemsPerPage" class="col-12 col-lg-12">
      <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
        <slot-component
            v-for="(item, index) in $slots.items"
            :key="index"
            :vnode="item"
        />
      </div>
    </div>
    <div v-else :class="columnWidths" v-for="(item, index) in $slots.items" :key="index">
      <slot-component :vnode="item"/>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    SlotComponent: {
      functional: true,
      render: (createElement, context) => context.data.attrs.vnode,
    },
  },

  props: {
    itemsPerPage: {
      type: Number,
      default: 4,
    },
  },

  computed: {
    columnWidths() {
      const itemsPerPage = Math.min(Math.max(this.itemsPerPage, 1), 4);
      return [
        "col-12",
        itemsPerPage === 1 ? "col-sm-12" : "col-sm-6",
        `col-md-${12 / itemsPerPage}`,
      ];
    },
  },

  mounted() {
    this.$nextTick(this.initializeCarousel);
  },

  updated() {
    this.initializeCarousel();
  },

  methods: {
    initializeCarousel() {
      const $owl = $(this.$refs.carouselContainer);
      if (this.$slots.items && $owl.children().length > 0) {
        $owl.owlCarousel({
          onInitialized() {
            $owl.find(".owl-carousel.owl-loaded").trigger("refresh.owl.carousel");
          },
          autoHeight: true,
          dots: true,
          items: this.itemsPerPage,
          responsive: {
            0: { items: 2 },
            576: { items: 2 },
            768: { items: this.itemsPerPage > 3 ? 3 : this.itemsPerPage },
            992: { items: this.itemsPerPage },
          },
          lazyLoad: false,
          loop: false,
          margin: 30,
          mouseDrag: true,
          nav: true,
          stagePadding: 5,
          navClass: [
            "owl-single-item-nav left carousel-control list-control-special",
            "owl-single-item-nav right carousel-control list-control-special",
          ],
          navText: [
            '<i class="owl-single-item-control fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="owl-single-item-control fa fa-angle-right" aria-hidden="true"></i>',
          ],
          smartSpeed: 350,
        });
      }
    },
  },
};
</script>
